module.exports = __webpack_public_path__ + "fonts/Poppins-Regular.8b6af8e5.ttf";